import React from "react";

import { IgChip, IgCustomTheme } from "@intelligems/ig-theme";
import { List, useTheme } from "@mui/material";
import { IgListItemLink } from "@src/components/Navigation/BaseSideNav/IgListItemLink";
import { BillingRoutes } from "@src/components/Utils/routes";

interface SideNavBarBodyProps {
  drawerOpen: boolean;
}
export const AdminSideNavBarBody = ({ drawerOpen }: SideNavBarBodyProps) => {
  return (
    <List sx={{ px: drawerOpen ? 2 : 4 }}>
      <IgListItemLink
        Route={BillingRoutes.overview}
        drawerOpen={drawerOpen}
        hasAccess={true}
        exact={true}
      />

      <IgListItemLink
        Route={BillingRoutes.agency}
        drawerOpen={drawerOpen}
        hasAccess={true}
        exact={true}
      />
    </List>
  );
};
